import React from 'react'
import {Redirect, withRouter} from 'react-router-dom'
import NavigationPrompt from 'react-router-navigation-prompt'
import {Form, SimpleRadiobox, withForm, TextInput, Errors, AutoComplete} from 'startlibs/lib/form'
import {Link, Dialog, Button, SplitColumnsContainer} from 'startlibs/lib/components'
import {withToggles, fetchConnect} from 'startlibs/lib/hocs'
import {AvatarUploadForm} from '../components/AvatarUploadForm'
import {ConfirmLeaveDialog} from '../components/ConfirmLeaveDialog'
import {postFetcher, getFetcher} from 'startlibs'
import {setProfile} from '../reducers'
import {getResource} from '../lib'
import styled from 'styled-components'
import {buildValidation, required} from '../lib/validation'
import URLSearchParams from 'url-search-params'

export const NewUserDialog = styled(Dialog)`
  max-width: 38rem;
  text-align: center;
  p {
    margin: auto 1rem;
  }
  img {
    max-width: 10rem;
    margin: 2rem auto 2rem;
  }
  h2 {
    padding-right: 0;
  }
  ${Dialog.Footer} {
     justify-content: center;
  }
`

@withRouter
@fetchConnect(({user}) => ({
  userEmail: user.email,
  firstSignIn: !user.hasProfile
}), {setProfile}, 'formProperties')
@withForm(setProfile)
@withToggles('confirmLeaveDialog', 'redirectToDashboard', 'welcomeDialog')
export class ProfileData extends React.PureComponent {

  signOut = () => {
    localStorage.removeItem('hasLogged')
    getFetcher('/api/logout').then(() => window.location = '/')
  }

  justActivated = (new URLSearchParams(this.props.location.search)).get('from') === 'activation'

  componentDidMount() {
    if (this.justActivated) {
      this.props.welcomeDialog.open()
    }
  }

  preValidation = buildValidation({
    firstName: required,
    lastName: required,
    specializations: (val) => val && val.filter(_ => typeof _ === 'string' && _.trim()).length && 'Specializations must have at least 3 characteres'
  }, (props) => ({...props, specializations: props.specializations.filter(_ => _.label)}))

  specializationValidation = (label) => ({success: {label}})

  fetchSpecializationSuggestions = (s) => getFetcher('/api/specializations?label=' + s)

  getSpecializationLabel = (_) => _.label

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.connector.submitProperties().then(({success, errors}, test, test2) => {
      if (!errors) {
        this.props.redirectToDashboard.open()
      }
    })
  }

  onFailure = (_, errors) => {console.log(errors)}

  render() {
    const {form, userEmail, welcomeDialog, firstSignIn, redirectToDashboard} = this.props
    return (
      <div className="content edit-profile provider-profile">
        {
          !firstSignIn &&
          <div><Button.Link className="return-home-button" icon="arrow-left" to="/">Home</Button.Link></div>
        }
        <div className="profile-header">
          <h1>Your profile</h1>
          {
            !firstSignIn &&
            <div className="profile-menu">
              <Link className="button nav-tab active" to="/profile">Profile</Link>
              <Link className="button nav-tab" skipTo="/account-settings">Settings</Link>
              <Link className="button nav-tab workstations" to="/workstations">Manage workstations</Link>
            </div>
          }
        </div>
        <SplitColumnsContainer viewportMinWidth={610} margin='big'>
          <div className="change-picture">
            <label>
                <span className="field-label">
                    Profile picture:
                </span>
            </label>
            <AvatarUploadForm
              form={form}
              path="picture"
              getResource={getResource}
              uploadFetcher={(formData) => postFetcher('/api/upload-profile-picture', formData)}
              defaultPicture="/public/user-avatar.png"
            />
            <Errors form={form} path="picture"/>
          </div>
          <div className="profile-type">
            <label>
                <span className="field-label">
                    Role:
                </span>
            </label>
            <div className="radio-list">
              <SimpleRadiobox
                form={form}
                path="physicianType"
                fieldValue="referring"
                label="Referring physician"
              />
              <SimpleRadiobox
                form={form}
                path="physicianType"
                fieldValue="radiologist"
                label="Radiologist"
              />
              <SimpleRadiobox
                form={form}
                path="physicianType"
                fieldValue="other"
                label="Other"
              />
            </div>
          </div>
        </SplitColumnsContainer>
        <Form
          form={form}
          url='/api/profiles'
          onSubmit={this.handleSubmit}
          preValidation={this.preValidation}
          onFailure={this.onFailure}
        >
          <SplitColumnsContainer viewportMinWidth={610} margin='big'>
            <TextInput
              form={form}
              path="firstName"
              placeholder="Ex: John"
              label="First name:"
            />
            <TextInput
              form={form}
              path="lastName"
              placeholder="Ex: Doe"
              label="Last name:"
            />
          </SplitColumnsContainer>
          <TextInput
            form={form}
            disabled
            value={userEmail}
            label="E-mail:"
            locked
          />
          <AutoComplete
            form={form}
            autoSelect
            getLabel={this.getSpecializationLabel}
            minQueryLength={2}
            validation={this.specializationValidation}
            fetchSuggestions={this.fetchSpecializationSuggestions}
            path="specializations"
            label="Specialization:"
            helpText={'(Optional)'}
            placeholder="Ex: Neurology"
          />
          <SplitColumnsContainer viewportMinWidth={610} margin='big'>
            <TextInput
              form={form}
              path="phoneNumber"
              setValue={(newValue,_,setValue) => setValue(newValue.replace(/[^0-9()\-+\s]/,''))}
              placeholder="(123) 456-7890"
              label="Phone number:"
            />
            <TextInput
              form={form}
              path="phoneNumber2"
              setValue={(newValue,_,setValue) => setValue(newValue.replace(/[^0-9()\-+\s]/,''))}
              helpText={'(Optional)'}
              placeholder="(123) 456-7890"
              label="Phone number 2:"
            />
          </SplitColumnsContainer>
          <TextInput
            form={form}
            path="address"
            placeholder="Ex: Sesame Street, 60 - Harlem"
            label="Address:"
          />
          <SplitColumnsContainer viewportMinWidth={610} margin='big'>
            <TextInput
              form={form}
              path="zipCode"
              placeholder="Ex: 10026"
              label="Zip code:"
            />
            <TextInput
              form={form}
              path="city"
              placeholder="Ex: New York"
              label="City:"
            />
          </SplitColumnsContainer>
          <SplitColumnsContainer viewportMinWidth={610} margin='big'>
            <TextInput
              form={form}
              path="state"
              placeholder="Ex: New York"
              label="State:"
            />
            <TextInput
              form={form}
              path="country"
              placeholder="Ex: USA"
              label="Country:"
            />
          </SplitColumnsContainer>
          <div className="profile-errors-container"><Errors form={form}/></div>
          <div className="profile-footer">
            <div className="footer-left-container"></div>
            {
              firstSignIn ?
                <Button onClick={this.signOut}>Sign out</Button>
                :
                <Button.Link to="/">Cancel</Button.Link>
            }
            <Button type="submit" disabled={!form.hasChanged && !this.justActivated} isLoading={form.isLoading}
                    highlight>{firstSignIn ? 'Save profile' : 'Save'}</Button>
          </div>
        </Form>
        <NavigationPrompt when={form.hasChanged}
                          beforeCancel={(cb) => window.history.replaceState('', '', null) || cb()}>
          {({onConfirm, onCancel}) => (
            <ConfirmLeaveDialog
              save={() => form.connector.submitProperties().then(({success, errors}) => errors ? onCancel() : onConfirm())}
              discard={onConfirm}
              isLoading={form.isLoading}
              closeDialog={onCancel}
            />
          )}
        </NavigationPrompt>
        {
          redirectToDashboard.isOpen &&
          <Redirect to="/"/>
        }
        {
          welcomeDialog.isOpen &&
          <NewUserDialog
            title="Account activated"
          >
            <Dialog.Content>
              <p>Your Horos Cloud account has been successfully activated!</p>
              <img alt="" src="/public/favicon.png"/>
              <p>Please complete your user profile.</p>
            </Dialog.Content>
            <Dialog.Footer className="center">
              <Button onClick={welcomeDialog.close} highlight>Complete profile</Button>
            </Dialog.Footer>
          </NewUserDialog>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/user/ProfileData.jsx